import React from 'react';
import './WishListIcon.scss';

import OdHeartFilledIcon from '../../../static/assets/svg/od-heart-filled-icon.svg';

const WishListIcon = props => {
  const {
    isShortlisted,
    dataLocale,
    onClickHandler,
    customStyles = {},
    wishlistWrapperStyle = {},
    wishListMode,
    isRelatedProduct,
    isPlpProduct,
    isBestSellerProduct,
  } = props;
  const { REMOVE_FROM_SHORTLIST, ADD_TO_SHORTLIST } = dataLocale;

  return (
    <>
      <div
        className={`wishlist wishlist--${wishListMode}`}
        style={wishlistWrapperStyle || {}}
        onClick={onClickHandler || (() => {})}
      >
        {isRelatedProduct ||
        isPlpProduct ||
        isBestSellerProduct ||
        wishListMode === 'plp-mobile' ? (
          <>
            {isShortlisted ? (
              <img alt="selected" className="cursor-pointer" src={OdHeartFilledIcon} />
            ) : (
              <img
                alt="select"
                className="cursor-pointer"
                src="https://static.lenskart.com/media/owndays/desktop/img/od-misc/od-heart-icon.svg"
              />
            )}
          </>
        ) : (
          <span
            className={`wishlist-icon--${
              wishListMode || 'main'
            } cursor-pointer text-center fa fs20 ${
              !isShortlisted ? 'fa-heart-o text-color-black' : 'fa-heart text-color-red'
            }`}
            style={customStyles || {}}
            title={isShortlisted ? REMOVE_FROM_SHORTLIST : ADD_TO_SHORTLIST}
          />
        )}
      </div>
    </>
  );
};

export default WishListIcon;
